import React from 'react';
import BrowserStepForm from './BrowserStepForm';
import ApiCallForm from './ApiCallForm';

const TestStepForm = ({
  apiCallMode,
  setApiCallMode,
  formData,
  setFormData,
  handleSaveStep,
  handleToggleSecret,
  handleValueModeChange,
  handleGenerateAssertion,
  isAssertionGenerating,
  genratedAssertions,
  TEST_ACTIONS,
  availableWorkflows,
  // API call related props
  isLoadingApiCalls,
  apiCallsError,
  availableApiCalls,
  selectedApiCallId,
  setSelectedApiCallId,
  handleSaveApiCall,
  editingApiCallIndex,
  setApiCall,
  setEditingApiCallIndex,
  handleKeyPress,
  error,
  // Screenshot related props
  stepScreenshot,
  setStepScreenshot,
  screenshotPreview,
  setScreenshotPreview,
  isUploadingScreenshot,
  setIsUploadingScreenshot,
  existingScreenshotUrl, // Add this prop
  onRemoveExistingScreenshot // Add callback to remove existing screenshot
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-sm font-medium text-gray-700 mb-3">
        {formData.editingStepIndex !== undefined ? 'Edit Step' : 'Add New Step'}
      </h3>
      
      {/* Display error message */}
      {error && (
        <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}
      
      {/* Add tab selection */}
      <div className="mb-4">
        <div className="flex bg-white rounded-lg">
          <button 
            type="button"
            className={`flex-1 py-3 px-4 text-center rounded-l-lg ${!apiCallMode ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
            onClick={() => setApiCallMode(false)}
          >
            Add Browser Step
          </button>
          <button 
            type="button"
            className={`flex-1 py-3 px-4 text-center rounded-r-lg ${apiCallMode ? 'bg-blue-500 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
            onClick={() => setApiCallMode(true)}
          >
            Add API Call
          </button>
        </div>
      </div>

      {!apiCallMode ? (
        <BrowserStepForm
          formData={formData}
          setFormData={setFormData}
          handleSaveStep={handleSaveStep}
          handleToggleSecret={handleToggleSecret}
          handleValueModeChange={handleValueModeChange}
          handleGenerateAssertion={handleGenerateAssertion}
          isAssertionGenerating={isAssertionGenerating}
          genratedAssertions={genratedAssertions}
          TEST_ACTIONS={TEST_ACTIONS}
          availableWorkflows={availableWorkflows}
          handleKeyPress={handleKeyPress}
          error={error}
          stepScreenshot={stepScreenshot}
          setStepScreenshot={setStepScreenshot}
          screenshotPreview={screenshotPreview}
          setScreenshotPreview={setScreenshotPreview}
          isUploadingScreenshot={isUploadingScreenshot}
          setIsUploadingScreenshot={setIsUploadingScreenshot}
          existingScreenshotUrl={existingScreenshotUrl}
          onRemoveExistingScreenshot={onRemoveExistingScreenshot}
        />
      ) : (
        <ApiCallForm
          isLoadingApiCalls={isLoadingApiCalls}
          apiCallsError={apiCallsError}
          availableApiCalls={availableApiCalls}
          selectedApiCallId={selectedApiCallId}
          setSelectedApiCallId={setSelectedApiCallId}
          handleSaveApiCall={handleSaveApiCall}
          editingApiCallIndex={editingApiCallIndex}
          setApiCall={setApiCall}
          setEditingApiCallIndex={setEditingApiCallIndex}
        />
      )}
    </div>
  );
};

export default TestStepForm; 